import { studentName, compareStudentNames } from "../../core/utils/studentName";
import { AllCommunityModule, ModuleRegistry, ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";

import { useEffect, useMemo, useState } from "react";
import { Select } from "antd";
import { Link } from "react-router";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { getAllStudentByClass } from "../../api/etudiants";
import { toast } from "sonner";
import { getAllClass } from "../../api/pedagogicElement";
import { useAcademicYear } from "../../core/common/context/AcademicYearContext";
import myTheme, { getColumnColor } from "../../style/agGridTheme/theme";
import {
  createNote,
  deleteStudentNote,
  getAllNoteHistory,
  getStudentNoteByMatiere,
  getSubjectAverages,
  importNote,
  templateNote,
  updateStudentNote,
} from "../../api/notes";
import { getAllEvaluationPeriodByLevel } from "../../api/generalParam";
import { getAllUEByPeriod } from "../../api/ue";
import { getMethodByYear } from "../../api/settings";
import { getAllEvaluationByPeriodAndLevel } from "../../api/evaluations";
import EditableCellRenderer, { navigateToEditableCellOnArrow } from "./editableCellRender";

import InfosAlertYearDisabled from "../../core/common/alerts/infosAlertYearDisabled";
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../core/common/autorisations/permissionsMap";
import { usePermissions } from "../../core/common/context/PermissionsUserContext";
import { useSelector } from "react-redux";
import { useCurrentClass } from "../../core/common/context/studentClassContext";
import ExportNoteModal from "./exportNoteModal";
import NoteSettingsModal from "./noteSettingsModal";
import NoteListStatistique from "./NoteListStatistique";
import { my_routes } from "../router/all_routes";
import "../user/admin/dashboard.css";
import "./noteList.css";

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);
interface Note {
  id?: string;
  __pendingCreate?: boolean;
  __pendingUpdate?: boolean;
  __pendingDelete?: boolean;
  EvaluationLevel?: any;
  id_evaluation: string;
  value?: number | string;
  commentaire?: string;
  key?: number;
}

interface StudentNotes {
  student: any;
  notes: Note[];
  moyenne?: any;
  mention?: string;
  key: number;
}

interface CustomColDef extends ColDef<StudentNotes, any> {
  evaluationId?: string;
  evaluationLevelId?: string;
  commentaire?: boolean;
}

type PendingNoteChange = {
  type: "create" | "update" | "delete";
  noteId?: string;
  payload: any;
};

const getMention = (value?: number): string => {
  if (value === undefined || value === null || isNaN(value)) return "Aucune";

  switch (true) {
    case value < 10:
      return "Contrôle";
    case value < 12:
      return "Passable";
    case value < 14:
      return "Assez bien";
    case value < 16:
      return "Bien";
    case value < 18:
      return "Très bien";
    default:
      return "Excellent";
  }
};

// condition pour vérifier si droit d'édition ou pas
const canEdit = (permissions: string[], isSuperAdmin: boolean): boolean => {
  return (
    [
      buildPermission(Resource.NOTE, Action.CREATE),
      buildPermission(Resource.NOTE, Action.UPDATE),
      buildPermission(Resource.NOTE, Action.DELETE),
    ].some((requiredPerm: any) => permissions.includes(requiredPerm)) ||
    isSuperAdmin
  );
};

// Tableau protéger des historiques
const ProtectedTabHistory = withPermission(
  (props: any) => (
    <AgGridReact
      rowData={props.filteredHistory}
      loading={props.loadingHistory}
      columnDefs={props.colHistoryDefs}
      defaultColDef={props.defaultColDef}
      pagination={true}
      paginationPageSize={40}
      // paginationAutoPageSize={true}
      rowSelection="multiple"
      domLayout="normal"
      gridOptions={{
        theme: myTheme, // le theme du tableau
        pagination: true,
        paginationPageSize: 40,
      }}
    />
  ),
  [buildPermission(Resource.NOTE, Action.READ)],
  "masquer",
);

// Tableau protéger des historiques
const ProtectedImportNote = withPermission(
  (props: any) => (
    <button
      className="dropdown-item"
      onClick={() => {
        const input = document.createElement("input");
        input.type = "file";
        input.accept = ".xlsx, .xls";
        input.onchange = (e) => {
          const files = (e.target as HTMLInputElement).files;
          if (files && files.length > 0) {
            props.handleImportExcel(files[0]);
          }
        };
        input.click();
      }}
    >
      <i className="ti ti-file-import me-1" />
      Importer
    </button>
  ),
  [buildPermission(Resource.NOTE, Action.CREATE)],
  "masquer",
);

// Bloc protege pour le classement des élèves
const ProtectedBlocClassement = withPermission(
  (props: any) => (
    <div className="dashboard-menu-item">
      <div className="dropdown h-100 dashboard-dropdown">
        <button
          className="dashboard-nav-link dashboard-btn dropdown-toggle"
          type="button"
          id="dropdownClassement"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="ionic icon ion-ribbon-a" />
          <span>Classement</span>
        </button>
        <ul
          className="dropdown-menu dashboard-dropdown-menu"
          aria-labelledby="dropdownClassement"
        >
          <li>
            <Link
              className="dropdown-item d-flex align-items-center"
              to={props.routes.classementByPromotion}
            >
              <i className="ti ti-trophy me-2" />
              Classement par promotion
            </Link>
          </li>
          <li>
            <Link
              className="dropdown-item d-flex align-items-center"
              to={props.routes.classementByClass}
            >
              <i className="ti ti-list-numbers me-2" />
              Classement par classe
            </Link>
          </li>
        </ul>
      </div>
    </div>
  ),
  [
    ...Object.values(Action).map((action) =>
      buildPermission(Resource.NOTE, action),
    ),
  ],
  "masquer",
);

// Bloc protege pour le classement des élèves
const ProtectedBlocExternalNote = withPermission(
  (props: any) => (
    <div className="dashboard-menu-item">
      <Link
        to={props.routes.noteExterne}
        className="dashboard-nav-link dashboard-btn"
      >
        <i className="fa fa-suitcase" />
        <span>Note Externe</span>
      </Link>
    </div>
  ),
  [
    ...Object.values(Action).map((action) =>
      buildPermission(Resource.EXTERNAL_NOTE, action),
    ),
  ],
  "masquer",
);

const NoteTable = () => {
  const routes = my_routes;

  // permissions de l'utilisateur connecté
  const { permissions } = usePermissions();
  const isSuperAdmin = useSelector(
    (state: any) => state.auth.user.isSuperAdmin,
  );

  const { selectedYear } = useAcademicYear();

  const [colDefs, setColDefs] = useState<any[]>([]);
  const [isLoadingGrid, setIsLoadingGrid] = useState(false); // état pour loader du grid
  const [pendingChanges, setPendingChanges] = useState<Record<string, PendingNoteChange>>({});
  const [isSaving, setIsSaving] = useState(false);
  const pendingChangeCount = Object.keys(pendingChanges).length;

  useEffect(() => {
    if (!pendingChangeCount) return;
    const message = "Vous avez des modifications non enregistrées. Voulez-vous vraiment quitter cette page ?";
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = message;
    };
    const handleLinkClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement | null;
      const link = target?.closest("a[href]") as HTMLAnchorElement | null;
      if (!link || link.target === "_blank" || link.href === window.location.href) return;
      if (!window.confirm(message)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("click", handleLinkClick, true);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("click", handleLinkClick, true);
    };
  }, [pendingChangeCount]);

  const [allStudent, setAllStudent] = useState<any[]>([]);
  const [allEvaluation, setAllEvaluation] = useState<any[]>([]);
  const [allClass, setAllClass] = useState<any[]>([]);
  const [allSubject, setAllSubject] = useState<any[]>([]);
  const [allPeriodEvaluation, setAllPeriodEvaluation] = useState<any[]>([]);
  const [isLoadingClasses, setIsLoadingClasses] = useState(false);
  const [isLoadingPeriods, setIsLoadingPeriods] = useState(false);
  const [isLoadingSubjects, setIsLoadingSubjects] = useState(false);
  const [isLoadingEvaluations, setIsLoadingEvaluations] = useState(false);

  const [allStudentNotes, setAllStudentNotes] = useState<StudentNotes[]>([]);
  const [allHistoryNote, setAllHistoryNote] = useState<any[]>([]); // liste del'historique des notes
  const [colHistoryDefs, setColHistoryDefs] = useState<any[]>([]);
  const [filteredHistory, setFilteredHistory] = useState<any[]>([]);
  const [loadingHistory, setLoadingHistory] = useState(true);

  const { selectedClassNote, setSelectedClassNote } = useCurrentClass();
  // const [selectedClassNote, setSelectedClass] = useState<any>();
  const [selectedPeriod, setSelectedPeriod] = useState<any>();
  const [selectedSubject, setSelectedSubject] = useState<any>();

  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement

  const [showModal, setShowModal] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  // Apply settings across all columns
  const defaultColDef = useMemo(() => {
    return {
      filter: true,
      resizable: true,
      sortable: true,
      suppressKeyboardEvent: navigateToEditableCellOnArrow,
    };
  }, []);
  // state pour les différentes vues des notes
  const [noteView, setNoteView] = useState<any>();

  const classOptions = useMemo(
    () =>
      allClass.map((classe) => ({
        label: `${classe?.Level?.label} - ${classe?.label}`,
        value: String(classe?.id),
      })),
    [allClass],
  );

  const periodOptions = useMemo(
    () =>
      allPeriodEvaluation.map((periode) => ({
        label: periode?.label,
        value: String(periode?.id),
      })),
    [allPeriodEvaluation],
  );

  const subjectOptions = useMemo(
    () =>
      allSubject.filter(Boolean).map((subject) => ({
        label: subject?.label,
        value: String(subject?.id),
      })),
    [allSubject],
  );

  const noteViewOptions = useMemo(
    () => [
      { label: "Notes", value: "" },
      ...(isSuperAdmin
        ? [{ label: "Historique Notes", value: "History" }]
        : []),
      ...allEvaluation.filter(Boolean).map((evaluationItem: any) => ({
        label: `${evaluationItem?.label} - ${evaluationItem?.abbreviation}`,
        value: String(evaluationItem?.id),
      })),
    ],
    [allEvaluation, isSuperAdmin],
  );

  const queueNoteChange = (key: string, change: PendingNoteChange) => {
    setPendingChanges((current) => ({ ...current, [key]: change }));
  };

  const savePendingChanges = async () => {
    const changes = Object.values(pendingChanges);
    if (!changes.length) return;
    setIsSaving(true);
    try {
      for (const change of changes) {
        if (change.type === "create") await createNote(change.payload);
        if (change.type === "update") await updateStudentNote(change.noteId || "", change.payload);
        if (change.type === "delete") await deleteStudentNote(change.noteId || "");
      }
      setPendingChanges({});
      toast.success(`${changes.length} changement${changes.length > 1 ? "s" : ""} enregistré${changes.length > 1 ? "s" : ""}`);
      await fetchStudentWithNotes();
    } catch (error: any) {
      toast.error(error.response?.data?.message || error.response?.data?.error || error.message || "Impossible d'enregistrer les changements");
    } finally {
      setIsSaving(false);
    }
  };

  // constructions de colonnes de notre tableau
  useEffect(() => {
    const MatriculeColumn = {
      field: "#",
      width: 120, // ✅ Largeur fixe en pixels
      valueGetter: (params: any) => params.data?.student?.matricule ?? "",
      cellRenderer: (record: any) => (
        <div>{record?.data?.student.matricule}</div>
      ),
    };

    const imgProfilColumn = {
      field: "Profile",
      headerName: "Profil",
      width: 80, // ✅ Largeur fixe en pixels
      cellRenderer: (record: any) => (
        <Link
          to={`/student-detail/${record?.data?.student.id}`}
          className="avatar avatar-md"
        >
          <ImageWithBasePath
            src="assets/img/parents/parent-13.jpg"
            className="img-fluid rounded-circle"
            alt="img"
            width={5}
            height={5}
          />
        </Link>
      ),
    };

    const nameColumn = {
      field: "Etudiants",
      //   autoHeight: true, // << Permet à la cellule de s'étendre en hauteur
      headerCheckboxSelection: true,
      checkboxSelection: true,
      flex: 1, // colonnes qui s'adaptent à la largeur
      minWidth: 150,
      //   width: 50,
      //   pinned: "left",
      headerName: "Nom prénom",
      initialSort: "asc" as const,
      comparator: (_a: any, _b: any, nodeA: any, nodeB: any) =>
        compareStudentNames(nodeA.data?.student, nodeB.data?.student),
      valueGetter: (params: any) => studentName(params.data?.student),
      cellRenderer: (record: any) => (
        <Link
          to={`/student-note?id_student=${record?.data?.student.id}`}
        >{studentName(record?.data?.student)}</Link>
      ),
    };
    const averageColumn = {
      field: "Moyenne",
      autoHeight: true, // << Permet à la cellule de s'étendre en hauteur
      flex: 1, // colonnes qui s'adaptent à la largeur
      minWidth: 150,
      //   headerCheckboxSelection: true,
      //   checkboxSelection: true,
      //   width: 50,
      //   pinned: "left",
      valueGetter: (params: any) => params.data?.moyenne ?? "",
      cellRenderer: (record: any) => <div>{record?.data?.moyenne || ""}</div>,
    };

    const mentionColumn = {
      field: "Mention",
      headerName: "Mention",
      autoHeight: true,
      width: 150,
      filter: "agTextColumnFilter",
      sortable: true,
      valueGetter: (params: any) => params.data?.mention,
      cellRenderer: (params: any) => {
        const mention = params.value;

        const mentionStyles: Record<
          string,
          { background: string; color: string }
        > = {
          Contrôle: { background: "#E74C3C", color: "#fff" }, // Rouge vif
          Passable: { background: "#F39C12", color: "#fff" }, // Orange fort
          "Assez bien": { background: "#2980B9", color: "#fff" }, // Bleu soutenu
          Bien: { background: "#27AE60", color: "#fff" }, // Vert fort
          "Très bien": { background: "#16A085", color: "#fff" }, // Vert-bleu
          Excellent: { background: "#8E44AD", color: "#fff" }, // Violet
        };

        const style = mentionStyles[mention] || {
          background: "#7F8C8D", // gris par défaut
          color: "#fff",
        };
        return (
          <div className="text-center">
            <span
              className="badge rounded-pill"
              style={{
                backgroundColor: style.background,
                color: style.color,
                // margin: 2,
                // borderRadius: 4,
                // textAlign: "center",
                // fontWeight: 700,
                // fontSize: 12,
              }}
            >
              {mention}
            </span>
          </div>
        );
      },
    };
    const specificNote = allEvaluation?.find(
      (evaluationItem: any) => evaluationItem.id === noteView,
    );

    // construire une colonne dynamique pour une évaluation spécifique
    if (noteView && specificNote) {
      const dynamicNoteColumn = {
        field: `note_${specificNote.id}`, // ✅ Doit être une string
        headerName: `${specificNote?.label} - ${specificNote?.abbreviation}`, // ✅ Texte de l'en-tête
        tooltipField: "weight", // facultatif
        editable: canEdit(permissions, isSuperAdmin), // ✅ rend la cellule éditable
        flex: 1, // colonnes qui s'adaptent à la largeur
        minWidth: 150,
        evaluationId: specificNote?.id, // utilisé dans le renderer
        evaluationLevelId: specificNote?.id_evaluationlevel,
        cellRenderer: EditableCellRenderer,

        // EditableCellRenderer, // ← ton renderer personnalisé
        valueGetter: (params: any) => {
          const noteObj = params.data.notes?.find(
            (n: any) => n.EvaluationLevel?.Evaluation?.id === specificNote.id,
          );
          return noteObj?.value ?? "";
        },
        valueSetter: (params: any) => {
          const newValue = parseFloat(params.newValue);

          if (
            params.newValue === null ||
            params.newValue === undefined ||
            params.newValue === ""
          ) {
            // Si la nouvelle valeur est null/undefined
            const noteObj = params.data.notes?.find(
              (n: any) =>
                n.EvaluationLevel?.Evaluation?.id === specificNote?.id,
            );
            if (noteObj) {
              // console.log(
              //   "Permission delete?: ",
              //   permissions.includes(
              //     buildPermission(Resource.NOTE, Action.DELETE),
              //   ) || isSuperAdmin,
              // );
              // La note existe, autoriser la modification (suppression) si permission
              return true;
              // return (
              //   permissions.includes(
              //     buildPermission(Resource.NOTE, Action.DELETE)
              //   ) || isSuperAdmin
              // );
            } else {
              // La note n'existe pas, ne rien faire
              return false;
            }
          } else {
            // Si la nouvelle valeur n'est pas null/undefined, vérifier qu'elle est entre 0 et 20
            if (isNaN(newValue) || newValue < 0 || newValue > 20) {
              toast.error("Veuillez entrer une note valide entre 0 et 20.");
              return false;
            }
          }

          // ✅ met à jour la note dans le bon tableau
          const noteObj = params.data.notes?.find(
            (n: any) => n.EvaluationLevel?.Evaluation?.id === specificNote?.id,
          );

          if (noteObj) {
            if (
              permissions.includes(
                buildPermission(Resource.NOTE, Action.UPDATE),
              ) ||
              isSuperAdmin
            ) {
              if (newValue !== undefined) noteObj.value = newValue;
              return true;
            }
            // ✅ pemettre la mise à jour dans la base
          } else {
            //permettre de créer une nouvelle note
            if (
              permissions.includes(
                buildPermission(Resource.NOTE, Action.CREATE),
              ) ||
              isSuperAdmin
            ) {
              return true;
            }
          }
        },
        cellStyle: {
          backgroundColor: getColumnColor(0), // ← fonction qui retourne une couleur
        },
      };
      const commentaireColumn = {
        field: "Commentaire",
        headerName: "Commentaire",
        autoHeight: true, // << Permet à la cellule de s'étendre en hauteur
        flex: 1, // colonnes qui s'adaptent à la largeur
        minWidth: 150,
        editable: true,
        evaluationId: specificNote?.id, // utilisé dans le renderer
        evaluationLevelId: specificNote?.id_evaluationlevel,
        commentaire: true,
        valueGetter: (params: any) => {
          const noteObj = params.data.notes?.find(
            (n: any) => n.EvaluationLevel?.Evaluation?.id === specificNote.id,
          );
          return noteObj?.commentaire ?? "";
        },
        cellRenderer: (record: any) => {
          const noteObj = record.data.notes?.find(
            (n: any) => n.EvaluationLevel?.Evaluation?.id === specificNote.id,
          );

          const commentaire = noteObj?.commentaire ?? " ";
          return <div>{commentaire}</div>;
        },
        valueSetter: (params: any) => {
          const newValue = params.newValue;

          if (newValue.length > 500) {
            toast.error("Le commentaire ne doit pas dépasser 500 caractères.");
            return false; // ❌ ne met pas à jour
          }
          const noteObj = params.data.notes?.find(
            (n: any) => n.EvaluationLevel?.Evaluation?.id === specificNote.id,
          );
          if (!noteObj?.value) {
            toast.error("Veuillez entrer une valeur pour la note d'abord.");
            return false; // ❌ ne met pas à jour
          }
        },
      };

      setColDefs([
        MatriculeColumn,
        // imgProfilColumn,
        nameColumn,
        dynamicNoteColumn,
        commentaireColumn,
        averageColumn,
        mentionColumn,
      ]);
      return;
    }

    const dynamicNoteColumns = allEvaluation?.map(
      (evaluationItem: any, index: number) => ({
        field: `note_${evaluationItem.id}`, // ✅ Doit être une string
        headerName: `${evaluationItem?.label} - ${evaluationItem?.abbreviation}`, // ✅ Texte de l'en-tête
        tooltipField: "weight", // facultatif
        editable: canEdit(permissions, isSuperAdmin), // ✅ rend la cellule éditable
        flex: 1, // colonnes qui s'adaptent à la largeur
        minWidth: 150,
        evaluationId: evaluationItem?.id, // utilisé dans le renderer
        evaluationLevelId: evaluationItem?.id_evaluationlevel,
        cellRenderer: EditableCellRenderer, // ← ton renderer personnalis
        valueGetter: (params: any) => {
          // console.log("params received: ", params.data?.notes);
          const noteObj = params.data.notes?.find(
            (n: any) => n.EvaluationLevel?.Evaluation?.id === evaluationItem.id,
          );
          return noteObj?.value ?? "";
        },
        valueSetter: (params: any) => {
          const newValue = parseFloat(params.newValue);

          if (
            params.newValue === null ||
            params.newValue === undefined ||
            params.newValue === ""
          ) {
            // Si la nouvelle valeur est null/undefined
            const noteObj = params.data.notes?.find(
              (n: any) =>
                n.EvaluationLevel?.Evaluation?.id === evaluationItem.id,
            );
            if (noteObj) {
              console.log(
                "Permission delete?: ",
                permissions.includes(
                  buildPermission(Resource.NOTE, Action.DELETE),
                ) || isSuperAdmin,
              );
              // La note existe, autoriser la modification (suppression) si permission
              return true;
              // return (
              //   permissions.includes(
              //     buildPermission(Resource.NOTE, Action.DELETE)
              //   ) || isSuperAdmin
              // );
            } else {
              // La note n'existe pas, ne rien faire
              return false;
            }
          } else {
            // Si la nouvelle valeur n'est pas null/undefined, vérifier qu'elle est entre 0 et 20
            if (isNaN(newValue) || newValue < 0 || newValue > 20) {
              toast.error("Veuillez entrer une note valide entre 0 et 20.");
              return false;
            }
          }

          // ✅ met à jour la note dans le bon tableau
          const noteObj = params.data.notes?.find(
            (n: any) => n.EvaluationLevel?.Evaluation?.id === evaluationItem.id,
          );

          if (noteObj) {
            if (
              permissions.includes(
                buildPermission(Resource.NOTE, Action.UPDATE),
              ) ||
              isSuperAdmin
            ) {
              if (newValue !== undefined) noteObj.value = newValue;
              return true;
            }
            // ✅ pemettre la mise à jour dans la base
          } else {
            //permettre de créer une nouvelle note
            if (
              permissions.includes(
                buildPermission(Resource.NOTE, Action.CREATE),
              ) ||
              isSuperAdmin
            ) {
              return true;
            }
          }
        },
        // 🎨 Couleur personnalisée par colonne
        cellStyle: {
          backgroundColor: getColumnColor(index), // ← fonction qui retourne une couleur
        },
      }),
    );

    // console.log("colonne dynamique: ", dynamicNoteColumns);
    setColDefs([
      MatriculeColumn,
      // imgProfilColumn,
      nameColumn,
      ...dynamicNoteColumns,
      averageColumn,
      mentionColumn,
    ]);
  }, [allEvaluation, noteView]);

  // construction des colonnes de l'historique
  const buildHistoryColumns = () => {
    const studentNameColumn = {
      field: "Etudiants",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      flex: 1, // colonnes qui s'adaptent à la largeur
      headerName: "Nom prénom",
      initialSort: "asc" as const,
      comparator: (_a: any, _b: any, nodeA: any, nodeB: any) =>
        compareStudentNames(nodeA.data?.StudentProfil, nodeB.data?.StudentProfil),
      valueGetter: (params: any) => studentName(params.data?.StudentProfil),
      cellRenderer: (record: any) => (
        <Link
          to={`/student-note?id_student=${record?.data?.StudentProfil.id}`}
        >{studentName(record?.data?.StudentProfil)}</Link>
      ),
    };
    const evaluationColumn = {
      field: "Evaluation",
      width: 120, // ✅ Largeur fixe en pixels
      valueGetter: (params: any) =>
        `${params.data?.Evaluation?.label} - ${params.data?.Evaluation?.typeNote}`,
    };
    const sessionColumn = {
      field: "Session",
      width: 120, // ✅ Largeur fixe en pixels
      valueGetter: (params: any) => `${params.data?.Evaluation?.session}`,
    };
    const oldValueColumn = {
      field: "Ancienne valeur",
      width: 120,
      valueGetter: (params: any) => params.data?.old_value,
    };
    const newValueColumn = {
      field: "Nouvelle valeur",
      width: 120,
      valueGetter: (params: any) => params.data?.new_value,
    };
    const userNameColumn = {
      field: "Auteur",
      width: 120,
      valueGetter: (params: any) =>
        `${params.data?.UserProfil?.firstname ?? ""} ${
          params.data?.UserProfil?.lastname ?? ""
        }`,
    };
    const editedDateColumn = {
      field: "Date modification",
      width: 120,
      valueGetter: (params: any) => params.data?.createdAt,
    };
    const actionColumn = {
      field: "Action",
      width: 120,
      valueGetter: (params: any) => params.data?.action,
    };
    setColHistoryDefs([
      studentNameColumn,
      sessionColumn,
      evaluationColumn,
      actionColumn,
      oldValueColumn,
      newValueColumn,
      userNameColumn,
      editedDateColumn,
    ]);
  };

  useEffect(() => {
    if (!allHistoryNote || allHistoryNote.length === 0) return;
    buildHistoryColumns();
  }, [allHistoryNote]);

  // télécharger le temmplate

  const getExcelFileTemplate = async () => {
    try {
      if (
        !selectedClassNote?.id ||
        !selectedPeriod?.id ||
        !selectedSubject?.id
      ) {
        toast.error(
          "Veuillez sélectionner une classe, une période et une matière.",
        );
        return;
      }
      const response = await templateNote(
        selectedClassNote?.id,
        selectedPeriod?.id,
        selectedSubject?.id_subjectUE,
      );
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);

      // Créer un lien temporaire
      const a = document.createElement("a");
      a.href = url;

      a.download = `noteTemplate_${selectedClassNote?.label}_${selectedPeriod?.label}_${selectedSubject?.label}_${selectedYear?.label}.xlsx`;
      a.click();
    } catch (error: any) {
      // console.error("Error:download Excel template", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const handleImportExcel = async (file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file); // Assuming file is an array of files

      toast.promise(importNote(formData), {
        loading: "Importation en cours...",
        success: () => {
          setIsLoadingGrid(true);
          fetchStudentWithNotes();
          return "Importé avec succès";
        },
        error: (error: any) => {
          // console.error("Error:import note Excel ", error);

          const messageError =
            error.response?.data?.message ||
            error.response?.data?.error ||
            error.message ||
            "Une erreur s'est produit, Réessayer plus tard";
          return (
            <div>
              <strong>{messageError}</strong>
              {error.response?.data?.errors &&
                error.response.data.errors.map((errorItem: any) => (
                  <div>
                    Ligne {errorItem?.row}: {errorItem?.message}
                  </div>
                ))}
            </div>
          );
        },
      });
    } catch (error: any) {
      // console.error("Error:import parent Excel ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // Fonction pour créer une note
  const createNewNote = async (
    id_studentProfil: string,
    id_subjectUE: string,
    note: Note,
  ) => {
    try {
      const formattedData = {
        id_studentProfil,
        id_evaluationLevel: note?.id_evaluation,
        id_subjectUE,
        value: note?.value,
        commentaire: note.commentaire,
      };
      await createNote(formattedData);
      toast.success("Note attribuer avec succès");
      await fetchStudentWithNotes();
    } catch (error: any) {
      // console.log("erreur création note: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  //Fonction pour éditer une note
  const updateNote = async (id_note: string, payload: any) => {
    try {
      // {commentaire, value, id_studentProfil, id_evaluationLevel, id_subjectUE } payload structure
      await updateStudentNote(id_note, payload);
      toast.success("note mise à jour");
      await fetchStudentWithNotes();
    } catch (error: any) {
      // console.log("erreur édition note: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // Fonction pour supprimer une note
  const deleteNote = async (id_note: string) => {
    try {
      await deleteStudentNote(id_note);
      toast.success("note supprimée ");
      await fetchStudentWithNotes();
    } catch (error: any) {
      // console.log("erreur suppression note: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // fonction pour récupérer les classes
  const fetchAllClass = async () => {
    setIsLoadingClasses(true);
    try {
      if (!selectedYear?.id) {
        setAllClass([]);
        setAllStudent([]);
        setAllPeriodEvaluation([]);
        setAllEvaluation([]);
        setAllStudentNotes([]);
        return;
      }
      const response = await getAllClass(
        selectedYear?.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      // console.log("all class: ", response.data);
      setAllClass(
        response.data
          .slice() // pour éviter de modifier directement la réponse
          .sort((a: any, b: any) => {
            // Tri par Level.label
            const levelCompare = a.Level.label.localeCompare(
              b.Level.label,
              "fr",
              { numeric: true },
            );
            if (levelCompare !== 0) return levelCompare;

            // Si même Level, tri par class label
            return a.label.localeCompare(b.label, "fr", { numeric: true });
          }),
      );
      if (
        !selectedClassNote ||
        response?.data.every((item: any) => item.id !== selectedClassNote?.id)
      )
        setSelectedClassNote(
          response.data.length > 0 ? response.data[0] : undefined,
        );
    } catch (error: any) {
      // console.log("erreur récupération des périodes d'évaluations: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoadingClasses(false);
    }
  };

  useEffect(() => {
    // setSelectedClassNote(undefined);
    // Reset all related states when the academic year changes
    setSelectedPeriod(undefined);
    setSelectedSubject(undefined);
    setAllEvaluation([]);
    setAllPeriodEvaluation([]);
    setAllSubject([]);
    setAllStudent([]);
    setAllStudentNotes([]);
    setAllHistoryNote([]);
    setFilteredHistory([]);
    setColDefs([]);
    setColHistoryDefs([]);
    setNoteView("");
    fetchAllClass();
  }, [selectedYear]);

  // fonction pour récupérer les périodes
  const fetchAllEvaluationPeriod = async () => {
    setIsLoadingPeriods(true);
    setSelectedPeriod(undefined);
    setAllPeriodEvaluation([]);
    try {
      if (!selectedClassNote?.Level?.id) {
        setAllEvaluation([]);
        setAllPeriodEvaluation([]);
        setAllStudent([]);
        setAllStudentNotes([]);
        setAllSubject([]);
        return;
      }
      const response = await getAllEvaluationPeriodByLevel(
        selectedClassNote?.Level?.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      const periodes =response.data.slice() // pour éviter de modifier directement la réponse
          .sort((a: any, b: any) => {
            // Tri par Subject.label
            // console.log("Label du sujet: ",a)
            return a?.label.localeCompare(b?.label, "fr", { numeric: true });
          }) ?? [];
      // console.log("all period by level: ", response.data);
      setAllPeriodEvaluation(periodes);
      setSelectedPeriod(
        periodes?.length > 0 ? periodes[0] : undefined,
      );
    } catch (error: any) {
      // console.log("erreur récupération des périodes d'évaluations: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoadingPeriods(false);
    }
  };

  useEffect(() => {
    fetchAllEvaluationPeriod();
    fetchStudent();
  }, [selectedClassNote]);

  //  fonction pour récupérer les matiéres
  const fetchAllSubject = async () => {
    setIsLoadingSubjects(true);
    setSelectedSubject(undefined);
    setAllSubject([]);
    try {
      if (!selectedYear || !selectedPeriod || !selectedClassNote) {
        setAllStudent([]);
        setAllStudentNotes([]);
        return;
      }
      // const response = await getAllSubject(selectedYear?.id);

      // on récupère les UE en fonction de la classe et de la période
      const allUE = await getAllUEByPeriod(
        selectedClassNote?.id,
        selectedPeriod?.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );

      // console.log("All subjects", allUE.data);
      if (allUE) {
        const allSubjects = allUE.data.map((ueItem: any) => ueItem.SubjectUEs)
        
        // console.log("allSubjects: ", allSubjects.flat(Infinity));
        const subjects = allSubjects
          .flat(Infinity)
          .map((subjectUEItem: any) => ({
            id_subjectUE: subjectUEItem?.id,
            label: subjectUEItem?.Subject?.label,
            id: subjectUEItem?.Subject?.id,
          })).slice() // pour éviter de modifier directement la réponse
          .sort((a: any, b: any) => {
            // Tri par Subject.label
            // console.log("Label du sujet: ",a)
            return a?.label.localeCompare(b?.label, "fr", { numeric: true });
          });

        // console.log("all subject ue: ", allSubjects.flat(Infinity));
        setAllSubject(subjects);
        setSelectedSubject(subjects?.length > 0 ? subjects[0] : undefined);
      }

      // setAllSubject(response.data);
      // setSelectedSubject(
      //   response.data?.length > 0 ? response.data[0] : undefined
      // );
    } catch (error: any) {
      // console.log("erreur récupération des matiéres: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoadingSubjects(false);
    }
  };
  
  useEffect(() => {
    if (!selectedClassNote || !selectedPeriod) {
      setAllSubject([]);
      setAllStudentNotes([]);
      return;
    }
    fetchAllSubject();
  }, [selectedClassNote, selectedPeriod]);

  const fetchAllEvaluation = async () => {
    setIsLoadingEvaluations(true);
    try {
      if (!selectedPeriod?.id || !selectedClassNote?.Level?.id) {
        setAllEvaluation([]);
        setAllPeriodEvaluation([]);
        setAllStudent([]);
        setAllStudentNotes([]);
        return;
      }

      const response = await getAllEvaluationByPeriodAndLevel(
        selectedClassNote?.Level.id,
        selectedPeriod?.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      const methodeCalcul = await getMethodByYear(
        selectedYear?.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      // console.log("methodClacul:", methodeCalcul.data);
      const formatData = response.data.map((evaluationItem: any) => {
        if (evaluationItem.typeNote === "Note Examen")
          return {
            ...evaluationItem,
            weight: methodeCalcul.data[0].weightNoteExamen,
          };
        if (evaluationItem.typeNote === "Note Classe")
          return {
            ...evaluationItem,
            weight: methodeCalcul.data[0].weightNoteClass,
          };
      });
      // console.log("all evaluation:", formatData);
      setAllEvaluation(formatData);
    } catch (error: any) {
      // console.log("erreur récupération des evaluations: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoadingEvaluations(false);
    }
  };

  useEffect(() => {
    fetchAllEvaluation();
  }, [selectedPeriod]);

  // Fonction pour récupérer les etudiants de la classe
  const fetchStudent = async () => {
    try {
      if (!selectedClassNote) {
        //   setAllEvaluation([]);
        //   setAllPeriodEvaluation([]);
        setAllStudent([]);
        //   setAllStudentNotes([]);
        //   setAllSubject([]);
        return;
      }
      const response = await getAllStudentByClass(
        selectedClassNote?.id,
        buildPermissionContext(Resource.NOTE, Action.READ),
      );
      // console.log("all student: ", response.data);
      setAllStudent(response.data);
      setIsLoading(false);
    } catch (error: any) {
      // console.log("erreur récupération des périodes d'évaluations: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // Fonction pour récuperer les notes d'une classe
  const fetchStudentNotes = async (id_student: string) => {
    try {
      if (!selectedSubject) {
        setAllStudent([]);
        setAllStudentNotes([]);
        setAllSubject([]);
        return;
      }
      // en attendant
      const response = await getStudentNoteByMatiere(
        id_student,
        selectedSubject?.id,
        selectedYear?.id,
      );
      // console.log("student all notes: ", response.data);
      const filterNoteBySubjectUE = response.data.filter(
        (noteItem: any) =>
          noteItem?.id_subjectUE === selectedSubject?.id_subjectUE,
      );
      // console.log("notes filter subject for student : ", filterNoteBySubjectUE);
      return filterNoteBySubjectUE;
      // setAllStudentNotes((prev) => [...prev, response.data]);
    } catch (error: any) {
      // console.log("erreur récupération des notes de la classe: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  const fetchStudentWithNotes = async () => {
    try {
      const fetchStudenWithNote = await Promise.all(
        allStudent.map(async (studentItem: any, index) => {
          const response = await fetchStudentNotes(
            studentItem?.id_studentProfil,
          );
          const averageAllSubject = await getSubjectAverages({
            id_studentProfil: studentItem?.id_studentProfil,
            id_academicYear: selectedYear?.id,
            id_subject: selectedSubject?.id,
            id_evaluationPeriod: selectedPeriod?.id,
          });

          // averageAllSubject.data.map((item: any) => {

          const averageSubject = averageAllSubject?.results[0]?.average;
          // console.log("moyenne fund: ",  averageAllSubject?.results[0]);
          const data: StudentNotes = {
            student: studentItem?.StudentProfil,
            notes: response,
            moyenne: averageSubject,
            mention:
              averageAllSubject.data?.results[0]?.mention ||
              getMention(averageSubject),
            key: index,
          };
          return data;
        }),
      );
      // console.log("final student: ", fetchStudenWithNote);
      setAllStudentNotes(fetchStudenWithNote);
      // return fetchStudenWithNote;
    } catch (error: any) {
      console.log("erreur récupération des moyennes des étudiants: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    } finally {
      setIsLoading(false);
      setIsLoadingGrid(false);
    }
  };

  useEffect(() => {
    if (!selectedSubject) {
      setAllStudentNotes([]);
      return;
    }
      setIsLoadingGrid(true);

    fetchStudentWithNotes();
  }, [selectedSubject]);

  // Logic to fetch and manage note history can be added here
  const fetchNoteHistory = async () => {
    try {
      if (!selectedSubject || !selectedClassNote || !selectedPeriod) {
        setAllHistoryNote([]);
        setLoadingHistory(false);
        return;
      }
      if (allHistoryNote.length === 0) {
        const response = await getAllNoteHistory();
        const filteredResponse = response.data.filter(
          (item: any) => item?.SubjectUE?.id === selectedSubject?.id_subjectUE,
        );
        setAllHistoryNote(response.data);
        setFilteredHistory(filteredResponse);
      } else {
        console.log("ici !");
        const filteredResponse = allHistoryNote.filter(
          (item: any) => item?.SubjectUE?.id === selectedSubject?.id_subjectUE,
        );
        setFilteredHistory(filteredResponse);
      }

      setLoadingHistory(false);
    } catch (error: any) {
      console.log("erreur récupération de l'historique des notes ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };
  useEffect(() => {
    if (noteView === "History") {
      fetchNoteHistory();
    }
  }, [noteView, selectedSubject]);

  return (
    <>
      <div className="page-wrapper notes-page">
        <div className="content">
          {/* Page Header */}
          <div className="mb-3 w-100">
            <div className="my-auto mb-2  flex-nowrap ">
              <h3 className="page-title mb-1">Gestion des Notes</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="#">Éléments Pédagogiques</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Notes
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* /Page Header */}
          {/* Barre des tâches */}
          <div className="dashboard-module-menu dashboard-menu-bar align-items-end">
            <div className="dashboard-menu-item">
              <div className="dropdown h-100 dashboard-dropdown">
                <button
                  className="dashboard-nav-link dashboard-btn dropdown-toggle"
                  type="button"
                  id="noteActionsDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="ti ti-settings" />
                  <span>Actions</span>
                </button>
                <div
                  role="menu"
                  className="dropdown-menu dashboard-dropdown-menu"
                  aria-labelledby="noteActionsDropdown"
                >
                  {selectedPeriod && selectedSubject && selectedClassNote && (
                    <button
                      className="dropdown-item d-flex align-items-center"
                      onClick={getExcelFileTemplate}
                    >
                      <i className="ti ti-upload me-2" />
                      Template
                    </button>
                  )}
                  <ProtectedImportNote handleImportExcel={handleImportExcel} />
                  <button
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => setShowModal(true)}
                  >
                    <i className="ti ti-file-type-xls me-2" />
                    Exporter
                  </button>
                  <button
                    className="dropdown-item d-flex align-items-center"
                    onClick={() => setShowSettings(true)}
                  >
                    <i className="ti ti-settings me-2" />
                    Paramètres
                  </button>
                </div>
              </div>
            </div>

            <ProtectedBlocExternalNote routes={routes} />
            <ProtectedBlocClassement routes={routes} />

            <div
              className="dashboard-menu-item flex-grow-1"
              style={{ minWidth: 180 }}
            >
              <label className="form-label fs-12 mb-1">Vue</label>
              <Select
                showSearch
                optionFilterProp="label"
                popupMatchSelectWidth={false}
                loading={isLoadingEvaluations}
                value={
                  noteViewOptions.some(
                    (option) => option.value === String(noteView ?? ""),
                  )
                    ? String(noteView ?? "")
                    : ""
                }
                onChange={(value) => {
                  setNoteView(value);
                }}
                style={{ width: "100%" }}
                placeholder="Notes"
                className="text-sm text-[#666666]"
                options={noteViewOptions}
              />
            </div>

            <div
              className="dashboard-menu-item flex-grow-1"
              style={{ minWidth: 190 }}
            >
              <label className="form-label fs-12 mb-1">Classe</label>
              <Select
                showSearch
                optionFilterProp="label"
                popupMatchSelectWidth={false}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toString()
                    .toLowerCase()
                    .includes(input.toString().toLowerCase())
                }
                loading={isLoadingClasses}
                disabled={isLoadingClasses}
                value={
                  classOptions.some(
                    (option) =>
                      option.value === String(selectedClassNote?.id),
                  )
                    ? String(selectedClassNote.id)
                    : undefined
                }
                onChange={(value) => {
                  const selected = allClass.find(
                    (opt) => String(opt.id) === String(value),
                  );
                  setSelectedClassNote(selected);
                }}
                style={{ width: "100%" }}
                placeholder={
                  isLoadingClasses ? "Chargement..." : "Sélectionner une classe"
                }
                options={classOptions}
              />
            </div>

            <div
              className="dashboard-menu-item flex-grow-1"
              style={{ minWidth: 170 }}
            >
              <label className="form-label fs-12 mb-1">Période</label>
              <Select
                showSearch
                optionFilterProp="label"
                popupMatchSelectWidth={false}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toString()
                    .toLowerCase()
                    .includes(input.toString().toLowerCase())
                }
                loading={isLoadingPeriods}
                disabled={isLoadingPeriods || !selectedClassNote}
                value={
                  periodOptions.some(
                    (option) => option.value === String(selectedPeriod?.id),
                  )
                    ? String(selectedPeriod.id)
                    : undefined
                }
                onChange={(value) => {
                  const selected = allPeriodEvaluation.find(
                    (opt) => String(opt.id) === String(value),
                  );
                  setSelectedPeriod(selected);
                }}
                style={{ width: "100%" }}
                placeholder={
                  isLoadingPeriods ? "Chargement..." : "Sélectionner une période"
                }
                options={periodOptions}
              />
            </div>

            <div
              className="dashboard-menu-item flex-grow-1"
              style={{ minWidth: 190 }}
            >
              <label className="form-label fs-12 mb-1">Matière</label>
              <Select
                showSearch
                optionFilterProp="label"
                popupMatchSelectWidth={false}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toString()
                    .toLowerCase()
                    .includes(input.toString().toLowerCase())
                }
                loading={isLoadingSubjects}
                disabled={
                  isLoadingSubjects || !selectedClassNote || !selectedPeriod
                }
                value={
                  subjectOptions.some(
                    (option) => option.value === String(selectedSubject?.id),
                  )
                    ? String(selectedSubject.id)
                    : undefined
                }
                onChange={(value) => {
                  const selected = allSubject.find(
                    (opt) => String(opt?.id) === String(value),
                  );
                  setSelectedSubject(selected);
                }}
                style={{ width: "100%" }}
                placeholder={
                  isLoadingSubjects ? "Chargement..." : "Sélectionner une matière"
                }
                options={subjectOptions}
              />
            </div>
          </div>
          {/* /Barre des tâches */}
          {!selectedYear?.statut && <InfosAlertYearDisabled />}

          <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
            <NoteListStatistique studentNotes={allStudentNotes} />
            {noteView !== "History" && (
              <button type="button" className="btn btn-primary ms-auto" onClick={savePendingChanges} disabled={!pendingChangeCount || isSaving}>
                {isSaving ? <span className="spinner-border spinner-border-sm me-2" /> : <i className="ti ti-device-floppy me-2" />}
                Enregistrer{pendingChangeCount > 0 && ` (${pendingChangeCount})`}
              </button>
            )}
          </div>
          {/* Tableau liste des notes */}
          {noteView === "History" ? (
            <>
              <div
                className="notes-grid"
              >
                {/*protected hitory tab*/}
                <ProtectedTabHistory
                  filteredHistory={filteredHistory}
                  loadingHistory={loadingHistory}
                  colHistoryDefs={colHistoryDefs}
                  defaultColDef={defaultColDef}
                />
              </div>
            </>
          ) : (
            <div
              className="notes-grid"
            >
              {isLoadingGrid && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(255,255,255,0.9)",
                    zIndex: 20,
                    flexDirection: "column",
                    gap: 12,
                  }}
                >
                  <div className="spinner-border text-primary" role="status" style={{ width: 48, height: 48 }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <div style={{ fontSize: 16, fontWeight: 600 }}>Chargement des données...</div>
                  <div style={{ color: "#6c757d" }}>Veuillez patienter</div>
                </div>
              )}

              {/* The AG Grid component, with Row Data & Column Definition props */}
              <AgGridReact
                rowData={allStudentNotes}
                loading={isLoading}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                pagination={true}
                paginationPageSize={50}
                // paginationAutoPageSize={true}
                rowSelection="multiple"
                domLayout="normal"
                gridOptions={{
                  theme: myTheme, // ← ICI ! 👈
                  pagination: true,
                  paginationPageSize: 40,
                }}
                // fonction qui gèrer la modificaton des note (celle ci est asynchrone maispas le setValue)
                onCellValueChanged={(event) => {
                  const { data, colDef, newValue } = event;
                  const customColdef = colDef as CustomColDef;
                  const evaluationId = customColdef.evaluationId;
                  const evaluationLevelId = customColdef.evaluationLevelId;
                  const commentaire = customColdef.commentaire;
                  const noteObj = data.notes?.find(
                    (n: any) =>
                      n.EvaluationLevel?.Evaluation?.id === evaluationId,
                  );
                  const changeKey = `${data?.student?.id}-${evaluationLevelId}`;

                  // si cest une note de commentaire
                  if (commentaire && commentaire === true) {
                    if (!noteObj) return;
                    queueNoteChange(changeKey, {
                      type: "update", noteId: noteObj.id, payload: {
                        commentaire: newValue, value: noteObj?.value,
                        id_studentProfil: data?.student.id, id_evaluationLevel: evaluationLevelId,
                        idSubjectUE: selectedSubject?.id_subjectUE,
                      },
                    });
                    return;
                  }

                  if (noteObj) {
                    // Si la note existe et que sa valeur est null ou undefined alors on supprime la note
                    if (
                      newValue === null ||
                      newValue === undefined ||
                      newValue === ""
                    ) {
                      if (noteObj.__pendingCreate) {
                        data.notes = data.notes.filter((note: any) => note !== noteObj);
                        setPendingChanges((current) => {
                          const next = { ...current };
                          delete next[changeKey];
                          return next;
                        });
                        return;
                      }
                      noteObj.value = "";
                      noteObj.__pendingDelete = true;
                      noteObj.__pendingUpdate = false;
                      queueNoteChange(changeKey, { type: "delete", noteId: noteObj.id, payload: {} });
                      return;
                    }

                    // console.log("cette note existe: ", noteObj?.value);
                    if (noteObj.__pendingCreate) {
                      queueNoteChange(changeKey, {
                        type: "create", payload: {
                          id_studentProfil: data?.student?.id,
                          id_subjectUE: selectedSubject?.id_subjectUE,
                          value: newValue, id_evaluationLevel: evaluationLevelId || "",
                        },
                      });
                      return;
                    }
                    noteObj.__pendingUpdate = true;
                    noteObj.__pendingDelete = false;
                    queueNoteChange(changeKey, {
                      type: "update", noteId: noteObj.id, payload: {
                        commentaire: noteObj?.commentaire, value: newValue,
                        id_studentProfil: data?.student.id, id_evaluationLevel: evaluationLevelId,
                        idSubjectUE: selectedSubject?.id_subjectUE,
                      },
                    });
                  } else {
                    // const noteMetaData= data.notes?.find(
                    // (n:any)=>n.EvaluationLevel?.id===evalu
                    // )
                    // console.log("cette note existe pas: ");

                    queueNoteChange(changeKey, {
                      type: "create", payload: {
                        id_studentProfil: data?.student?.id,
                        id_subjectUE: selectedSubject?.id_subjectUE,
                        value: newValue, id_evaluationLevel: evaluationLevelId || "",
                      },
                    });
                    data.notes = data.notes || [];
                    data.notes.push({
                      __pendingCreate: true,
                      value: newValue,
                      id_evaluation: evaluationLevelId || "",
                      EvaluationLevel: {
                        id: evaluationLevelId,
                        Evaluation: { id: evaluationId },
                      },
                    });
                    //function pour créer une nouvelle note
                  }
                }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Modal d'export des notes */}
      <ExportNoteModal
        show={showModal}
        metaData={{ classes: allClass }}
        onClose={() => setShowModal(false)}
      />

      <NoteSettingsModal
        show={showSettings}
        onClose={() => setShowSettings(false)}
      />
    </>
  );
};

export default NoteTable;
